import Vue from 'vue';
import '@/assets/stylesheets/v2/_text-area.scss';
export default Vue.extend({
    props: {
        color: {
            type: String,
            default: 'black',
        },
        hint: {
            type: String,
            default: null,
        },
        errorMessages: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: 'Type here',
        },
        value: {
            type: String,
            default: '',
        },
        counter: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        dataCy: {
            type: String,
            default: undefined,
        },
    },
    render(createElement) {
        const self = this;
        return createElement('v-textarea', {
            class: 'text-area',
            props: {
                autoGrow: true,
                color: self.color,
                errorMessages: self.errorMessages,
                label: self.label,
                placeholder: self.placeholder,
                rows: '1',
                value: self.value,
                counter: self.counter,
                hint: self.hint,
                persistentHint: !!self.hint,
                disabled: self.disabled,
            },
            attrs: {
                'data-cy': self.dataCy,
            },
            on: {
                input: (val) => {
                    self.$emit('input', val);
                },
            },
        });
    },
});
